import { render } from "./WebshopPaymentNavBar.vue?vue&type=template&id=60f0ac54&scoped=true&ts=true"
import script from "./WebshopPaymentNavBar.vue?vue&type=script&lang=ts"
export * from "./WebshopPaymentNavBar.vue?vue&type=script&lang=ts"

import "./WebshopPaymentNavBar.vue?vue&type=style&index=0&id=60f0ac54&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f0ac54"]])

export default __exports__